export default __webpack_public_path__ + "static/media/recuadroTres.74583ee7.png";